var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3957 6.60895L8.86944 6.60864C8.58125 6.60864 8.34766 6.84221 8.34766 7.13039V9.21524C8.34766 9.50336 8.58125 9.73699 8.86941 9.73699H12.5446C12.1422 10.7814 11.391 11.656 10.4327 12.2118L11.9998 14.9246C14.5136 13.4707 15.9998 10.9198 15.9998 8.06427C15.9998 7.65767 15.9698 7.36702 15.9099 7.03974C15.8643 6.79108 15.6485 6.60895 15.3957 6.60895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 12.8695C6.20153 12.8695 4.63141 11.8868 3.78813 10.4326L1.07544 11.9962C2.45591 14.3887 5.04197 15.9999 8.0001 15.9999C9.45125 15.9999 10.8205 15.6092 12.0001 14.9283V14.9246L10.433 12.2117C9.71619 12.6275 8.88669 12.8695 8.0001 12.8695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9284V14.9247L10.4329 12.2119C9.71609 12.6276 8.88666 12.8696 8 12.8696V16.0001C9.45116 16.0001 10.8205 15.6094 12 14.9284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13044 7.99994C3.13044 7.11341 3.37238 6.28401 3.78803 5.56722L1.07534 4.00366C0.390687 5.17951 0 6.54507 0 7.99994C0 9.45482 0.390687 10.8204 1.07534 11.9962L3.78803 10.4327C3.37238 9.71588 3.13044 8.88647 3.13044 7.99994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 3.13044C9.17294 3.13044 10.2503 3.54719 11.0917 4.24041C11.2993 4.41141 11.601 4.39906 11.7912 4.20891L13.2684 2.73172C13.4841 2.51597 13.4688 2.16281 13.2383 1.96288C11.8284 0.739781 9.99406 0 8.0001 0C5.04197 0 2.45591 1.61116 1.07544 4.00372L3.78813 5.56728C4.63141 4.11312 6.20153 3.13044 8.0001 3.13044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0916 4.24041C11.2992 4.41141 11.601 4.39906 11.7911 4.20891L13.2683 2.73172C13.484 2.51597 13.4686 2.16281 13.2382 1.96288C11.8283 0.73975 9.99397 0 8 0V3.13044C9.17281 3.13044 10.2502 3.54719 11.0916 4.24041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_2053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.173f9033cb60234d147bf2cc682cb043.svg";
export { ForwardRef as ReactComponent };